import { Flex } from "atoms/grid";
import { colors } from "lib/theme";
import ReactLoading from "react-loading";
import styled from "styled-components";
import { size } from "styled-system";

const Wrapper = styled(Flex)`
  color: ${(p) => colors[p.color] || p.color};
  ${size};
`;
Wrapper.defaultProps = {
  alignItems: "center",
  justifyContent: "center",
};

const Loading = ({ color = colors.pink[500], mt = null, ...props }) => (
  <Wrapper color={color} mt={mt} data-cy="loading">
    <ReactLoading {...props} />
  </Wrapper>
);

Loading.defaultProps = {
  type: "bubbles",
  height: 100,
  width: 100,
};

export default Loading;
